import { useApolloClient } from '@apollo/client';
import { useCreateUserMutation } from 'src/generated/graphql';
import { updateShowCache, updateUserCache } from 'src/apollo/cache/update';

interface CreateUserVariables {
  token: string;
  name: string;
  email: string;
  password: string;
  emailOptIn: boolean;
  marketingData: any;
}

export default function useCreateUser() {
  const client = useApolloClient();
  const [createUserMutation] = useCreateUserMutation();

  const createUser = (variables: CreateUserVariables) => {
    return createUserMutation({ variables }).then(res => {
      if (res.data) {
        updateUserCache({ client, user: res.data.createUser.user });
        updateShowCache({ client, show: res.data.createUser.show });
        localStorage.setItem('show-mobile-warning', 'true');
      }
    });
  };

  return createUser;
}
